import React from "react";


export enum DeviceType {
    Computer = 0,
    Tablet = 1,
    Mobile = 2
}

export const DeviceContext = React.createContext(DeviceType.Computer);